import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { IApplicationTaxRequest, SignerInput } from '@ebb-v2/ebb-integration';

export interface ITaxRequest {
  isMarried: boolean;
  name: string;
  spouseName: string;
}

@Component({
  selector: 'ebb-portal-dialog-taxrequest',
  templateUrl: './dialog-taxrequestform.component.html'
})
export class DialogtaxrequestformComponent implements OnInit {
  public formtaxrequest: FormGroup;
  public currentDate: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  public innerHeight;
  public yearquestion = '';
  constructor(
    public dialogRef: MatDialogRef<DialogtaxrequestformComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IApplicationTaxRequest,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.innerHeight = window.innerHeight;
    this.initializeForm();
  }

  private initializeForm(): void {
    const d = new Date();
    let y = d.getFullYear() - 1;
    const m = d.getMonth() +1;
    if(this.data.taxYear === null || this.data.taxYear === undefined){
      this.data.taxYear ='';
    }
if(this.data.taxYear.length >0){
y = Number.parseInt(this.data.taxYear);
}else{
  y = d.getFullYear() - 2;
}
  
       
 

    this.yearquestion = "What was this person's filing status in " + y + '?';

    this.formtaxrequest = this.fb.group({
      nameFirst: ['', Validators.required],
      nameInitial: [''],
      nameLast: ['', Validators.required],
      nameFirstSpouse: ['', Validators.required],
      nameInitialSpouse: [''],
      nameLastSpouse: ['', Validators.required],
      householdStatus: ['', Validators.required]
    });
  }
  
  public onChangeEvent(event: MatRadioChange): void {
    this.data.isMarried = this.setIsMarried(event.value);

    if (this.data.isMarried) {
      this.formtaxrequest.get('nameFirstSpouse').enable();
      this.formtaxrequest.get('nameInitialSpouse').enable();
      this.formtaxrequest.get('nameLastSpouse').enable();
    } 
    else {
      this.formtaxrequest.get('nameFirstSpouse').setValue('');
      this.formtaxrequest.get('nameFirstSpouse').disable();
      this.formtaxrequest.get('nameInitialSpouse').setValue('');
      this.formtaxrequest.get('nameInitialSpouse').disable();
      this.formtaxrequest.get('nameLastSpouse').setValue('');
      this.formtaxrequest.get('nameLastSpouse').disable();
    }
  }

  public onSave(): void {
    const signer1: SignerInput = {} as SignerInput;
    signer1.signerNameFirst = (this.formtaxrequest.get('nameFirst').value).trim();
    signer1.signerNameMiddle = (this.formtaxrequest.get('nameInitial').value).trim();
    signer1.signerNameLast = (this.formtaxrequest.get('nameLast').value).trim();
    signer1.clientId = '';
    signer1.recipientId = '';
    signer1.viewUrl = '';

    this.data.signer1 = signer1;
    const signer2: SignerInput = {} as SignerInput;
    signer2.signerNameFirst = (this.formtaxrequest.get('nameFirstSpouse').value).trim();
    signer2.signerNameMiddle = (this.formtaxrequest.get('nameInitialSpouse').value).trim();
    signer2.signerNameLast = (this.formtaxrequest.get('nameLastSpouse').value).trim();
    signer2.clientId = '';
    signer2.recipientId = '';
    signer2.viewUrl = '';
    this.data.signer2 = signer2;
    this.data.isMarried = this.setIsMarried(this.formtaxrequest.get('householdStatus').value);

    let closeForm: boolean = true;

    if (this.data.isMarried) {
      if (signer1.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirst').setValue('');
        closeForm = false;
      }
      if (signer1.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLast').setValue('');
        closeForm = false;
      }
      if (signer2.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirstSpouse').setValue('');
        closeForm = false;
      }
      if (signer2.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLastSpouse').setValue('');
        closeForm = false;
      }
    } else {
      if (signer1.signerNameFirst.length === 0) {
        this.formtaxrequest.get('nameFirst').setValue('');
        closeForm = false;
      }
      if (signer1.signerNameLast.length === 0) {
        this.formtaxrequest.get('nameLast').setValue('');
        closeForm = false;
      }
    }

    if (closeForm === true) {
        this.dialogRef.close(this.data);
    }
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }

  private setIsMarried(input: string) : boolean {
    if(input === 'Married Filing Jointly')  {
      return true;
    }

    return false;
  }
}
